import { useFormContext } from "react-hook-form";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

export default function DiagnosisSection() {
  const {
    register,
    formState: { errors }
  } = useFormContext();

  return (
    <div className="space-y-2">
      <Textarea
        {...register("diagnosis")}
        placeholder="Enter diagnosis (e.g. Type 2 Diabetes Mellitus, Hypertension...)"
        rows={3}
        className={cn(
          "text-xs border border-input rounded-md bg-background transition-all duration-200",
          "focus:border-ring focus:outline-none focus-visible:ring-0",
          "hover:border-ring/60 placeholder:text-muted-foreground placeholder:font-normal",
          "resize-none min-h-[72px]",
          errors.diagnosis && "border-destructive/30 bg-destructive/5 focus:border-destructive"
        )}
      />
      {errors.diagnosis && (
        <p className="text-xs text-destructive mt-1">{errors.diagnosis.message as string}</p>
      )}
    </div>
  );
}